<template lang="html">
  <v-stepper :value="statusNumber"
             alt-labels class="my-3 pt-2 arrow-stepper">
    <v-stepper-header>
      <v-stepper-step step="1" class="py-0"
                      :complete="statusNumber > 1">
        Scheduled
      </v-stepper-step>

      <v-divider :class="{'completed': statusNumber > 1}"></v-divider>

      <v-stepper-step step="2" class="py-0"
                      :complete="statusNumber > 2">
        In Transit
      </v-stepper-step>

      <v-divider :class="{'completed': statusNumber > 2}"></v-divider>

      <v-stepper-step step="3" class="py-0"
                      :complete="statusNumber == 3">
        Delivered
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import { loadStatus } from '@/types';

export default {
  name: 'ProgressArrows',
  props: {
    status: {
      required: true,
      type: String,
      default: 'Scheduled',
    },
    showPaid: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    statusNumber() {
      let status;
      switch (this.status) {
        case loadStatus.SCHEDULED:
          status = 1;
          break;
        case loadStatus.IN_TRANSIT:
          status = 2;
          break;
        case loadStatus.DELIVERED:
          status = 3;
          break;
        default:
          status = 0;
      }
      return status;
    },
  },
};
</script>

<style >
  .theme--light .arrow-stepper.v-stepper {
    background-color: transparent;
    box-shadow: none;
  }

  .theme--light .arrow-stepper.v-stepper .v-stepper__step__step {
    color: transparent;
    margin-bottom: 0;
  }

  .theme--light .arrow-stepper.v-stepper .v-divider {
    border-width: 2px;
    margin-top: 10px;
  }

  .theme--light .arrow-stepper.v-stepper .v-divider.completed {
    background-color: #88a2aa;
  }

  @media only screen and (max-width: 959px) {
    .arrow-stepper.v-stepper .v-stepper__label {
      display: flex;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/ProgressArrows2.vue